import { Component } from '@angular/core';

@Component({
  selector: 'pds-form-actions',
  templateUrl: './form-actions.component.html',
  styleUrls: ['./form-actions.component.scss'],
  standalone: false,
})
export class FormActionsComponent {}
